<app-chat-widget></app-chat-widget>

<footer class="main-footer-area">
    <div class="container">
        <div class="row">

            <!-- Logo Section -->
            <div class="col-lg-3 col-md-6 mb-4">
                <div class="footer-logo-text">
                    <img src="/assets/images/NeoJobz_192_192-1.svg" width="200" height="50" alt="">
                </div>
                <p class="footer-tagline">
                    Connecting Team with Opportunity
                </p>
            </div>

            <!-- Quick Links -->
            <div class="col-lg-2 col-md-6 mb-4">
                <h5 class="footer-title-text">Quick Links</h5>
                <a class="footer-link-style" (click)="goTo('/about-us')">About Us</a>
                <a href="#" class="footer-link-style">Career</a>
                <a href="#" class="footer-link-style">Press</a>
                <a class="footer-link-style" (click)="goTo('/blog')">Blog</a>
            </div>

            <!-- For Candidates -->
            <div class="col-lg-2 col-md-6 mb-4">
                <h5 class="footer-title-text">For Candidates</h5>
                <a href="#" class="footer-link-style">Browse Jobs</a>
                <a href="#" class="footer-link-style">Job Alerts</a>
                <a href="#" class="footer-link-style">Career Tips</a>
            </div>

            <!-- For Employers -->
            <div class="col-lg-2 col-md-6 mb-4">
                <h5 class="footer-title-text">For Employers</h5>
                <a href="#" class="footer-link-style">Post a Job</a>
                <a href="#" class="footer-link-style">Hire Talent</a>
                <a class="footer-link-style" (click)="goTo('/products')">Pricing</a>
            </div>

            <!-- Support -->
            <div class="col-lg-3 col-md-6 mb-4">
                <h5 class="footer-title-text">Support</h5>
                <a class="footer-link-style" (click)="goTo('/contact-us')">Contact Us</a>
                <!-- <a href="#" class="footer-link-style">Help Center</a> -->
                <a class="footer-link-style" (click)="goTo('/terms-and-conditions')">Terms & Conditions</a>

                <div class="footer-social-icons mt-3">
                    <a href="https://www.facebook.com/whiterobein"><i class="bi bi-facebook"></i></a>
                    <a href="https://twitter.com/whiterobein"><i class="bi bi-twitter"></i></a>
                    <a href="https://instagram.com/whiterobein"><i class="bi bi-instagram"></i></a>
                    <a href="https://linkedin.com/company/whiterobein"><i class="bi bi-linkedin"></i></a>
                    <a href="https://linkedin.com/company/whiterobein"><i class="bi bi-youtube"></i></a>
                </div>
            </div>

        </div>
    </div>

    <!-- Bottom Copyright -->
    <div class="footer-bottom-bar">
          © {{ currentYear }}  All rights reserved. | <li><a class="pointer" (click)="goTo('/privacy')" class="footer-bottom-link">Privacy Policy</a></li> | <li><a class="pointer" (click)="goTo('/terms-and-conditions')" class="footer-bottom-link">Terms and Conditions</a> </li>|<li> <a class="pointer" (click)="goTo('/pricing-policy')" class="footer-bottom-link">Pricing Policy</a> </li>| <li><a class="pointer" (click)="goTo('/refund-policy')" class="footer-bottom-link">Refund Policy</a></li> | <li><a class="pointer" (click)="goTo('/cancellation-policy')" class="footer-bottom-link">Cancellation Policy</a></li>
    </div>

</footer>
<!-- <footer class="footer">

    <div class="container text-center">
        <h3 class="section-title text-white">Get To Know Us More</h3>
        <p class="footer-description">
            How NeoJobz, a digital platform, is offering endless possibilities and uniting hearts<br>all at the same time.
            
        </p>


        <a class="contact-btn mt-4" (click)="goTo('/contact-us')">
            Contact
            <span class="arr-btn">
                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="currentColor"
                    class="bi bi-arrow-up-right" viewBox="0 0 16 16">
                    <path fill-rule="evenodd"
                        d="M14 2.5a.5.5 0 0 0-.5-.5h-6a.5.5 0 0 0 0 1h4.793L2.146 13.146a.5.5 0 0 0 .708.708L13 3.707V8.5a.5.5 0 0 0 1 0z" />
                </svg>
            </span>
        </a> 

        <div class="footer-bottom">
            <p> © {{currentYear}} All Rights Reserved |
                 <a (click)="goTo('/privacy')" style="cursor: pointer;">Privacy Policy</a> |
                  <a (click)="goTo('/terms-and-conditions')" style="cursor: pointer;">Terms and Conditions</a> |
                   <a (click)="goTo('/pricing-policy')" style="cursor: pointer;">Pricing Policy</a> |
                    <a (click)="goTo('/refund-policy')" style="cursor: pointer;">Refund Policy</a> |
                     <a (click)="goTo('/cancellation-policy')" style="cursor: pointer;">Cancellation Policy</a>
                    </p>
        </div>
        <hr>
        <div class="footer-down-links">
            <div>
                <img src="assets/images/NeoJobz_192_192-1.svg" width="200" height="50" alt="">
                <img src="assets/images/NeoJobz_Brandname_1.svg" width="200" height="50" alt=""> 
            </div>
            <div class="footer-links">
                <a class="pointer" (click)="goTo('/')" >Home</a>
                <a class="pointer" (click)="goTo('/about-us')" >About</a>
                <a class="pointer" (click)="goTo('/our-services')" >Services</a>
                <a class="pointer" href="https://blog.whiterobe.in/" target="_blank" >Blog</a>
            </div>

            <div class="social-icons">
                <a href="#"><i class="fab fa-discord"></i></a> 
                <a href="https://www.facebook.com/whiterobein" target="_blank"><i class="fa fa-facebook-square"
                        aria-hidden="true"></i>
                </a>
                <a href="https://x.com/Whiterobein" target="_blank"><i class="fab fa-x-twitter" aria-hidden="true"></i></a>

                <a href=" https://www.instagram.com/whiterobe.in/ " target="_blank"><i class="fa fa-instagram"
                        aria-hidden="true"></i></a>
                <a href="https://www.linkedin.com/company/whiterobe" target="_blank"><i class="fa fa-linkedin-square"
                        aria-hidden="true"></i>

                </a>

                <a href="https://in.pinterest.com/whiterobein/" target="_blank"><i class="fa fa-pinterest-square"
                        aria-hidden="true"></i>

                </a>
                <a href="https://www.youtube.com/@WhiteRobein/" target="_blank"><i class="fa-brands fa-youtube"></i>

                </a>
                <a href="https://www.youtube.com/@WhiteRobein/" target="_blank"><i class="fa-brands fa-app-store-ios"></i>
                </a>
                <a href="https://play.google.com/store/apps/details?id=com.app.whiterobe" target="_blank"><i class="fa-brands fa-google-play"></i>
                </a> 
            </div>
        </div>
    </div>
</footer> -->